import { render, staticRenderFns } from "./LiveCounterCell.vue?vue&type=template&id=20bd0d1c"
import script from "./LiveCounterCell.vue?vue&type=script&lang=js"
export * from "./LiveCounterCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports